import { Component } from '@angular/core';

@Component({
  selector: 'app-trafik-left',
  templateUrl: './trafik-left.component.html',
  styleUrls: ['./trafik-left.component.css']
})
export class TrafikLeftComponent {
  // We can remove the console.error since it was likely for testing
} 